export function emailIsValid(email: string): boolean {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}

function emailIsValidEither(
  em: string,
): { tag: "err" } | { tag: "parsed"; parsed: string } {
  return emailIsValid(em) ? { tag: "parsed", parsed: em } : { tag: "err" };
}

export const emailValidation = emailIsValidEither;
export const checkEmail = emailIsValidEither;
